import userReducer from "@/components/customer/ducks/reducer"
import internalReducer from "@/components/customer/internal/ducks/reducer"
import { combineReducers } from "@reduxjs/toolkit"

const customerReducer = combineReducers({
  internal: internalReducer,
  user: userReducer,
})

export default customerReducer
